// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__fV1k6","title":"Banner_title__fbIBx","text":"Banner_text__Edd-p","btn":"Banner_btn__+mHSG","whale":"Banner_whale__7oLfb"};